import { Outlet } from 'react-router';
import { CalendarCheck, ChatCircleDots, House, ListBullets } from '@phosphor-icons/react';
import { useTenant } from '@/app/tenant-context.ts';
import { BottomNav } from '@/components/BottomNav.tsx';
import { useManifest } from '@/lib/pwa.ts';
import { BookingFlow } from '@/features/booking/BookingFlow.tsx';

export function ClientShell() {
  const { base, slug } = useTenant();
  useManifest(slug, 'client');
  return (
    <>
      <main className="app-page" id="main">
        <Outlet />
      </main>
      <BottomNav
        label="Разделы"
        items={[
          { to: base, label: 'Главная', icon: House, end: true },
          { to: `${base}services`, label: 'Услуги', icon: ListBullets },
          { to: `${base}my`, label: 'Моя запись', icon: CalendarCheck },
          { to: `${base}assistant`, label: 'Помощник', icon: ChatCircleDots },
        ]}
      />
      <BookingFlow />
    </>
  );
}
